const registersDefaults = [
	{ id: -1, name: 'Ej publicerade' },
	{ id: 0, name: '- Alla -' },
];

export default (
	state = {
		loading: true,
		list: [],
		register: 1,
		registers: [],
		registersDefaults,
		originalFileName: '',
		showNewLawDocument: false,
		createdSblId: -1,
	},
	action
) => {
	switch (action.type) {
		case 'FETCH_LAWDOCUMENTS_BEGIN':
			return { ...state, loading: true };
		case 'FETCH_LAWDOCUMENTS_SUCCESS':
			return { ...state, list: action.payload, loading: false, register: action.register };
		case 'FETCH_REGISTERS_BEGIN':
			return { ...state, loading: true };
		case 'FETCH_REGISTERS_SUCCESS':
			return { ...state, registers: action.payload, loading: false };
		case 'FILTER_LAWDOCUMENTS':
			return { ...state, filter: action.payload };
		case 'LAWDOCUMENT_CHANGE_ORIGINAL_FILENAME':
			return { ...state, originalFileName: action.payload };
		case 'LAWDOCUMENT_SHOW_NEW':
			return { ...state, showNewLawDocument: true };
		case 'LAWDOCUMENT_HIDE_NEW':
			return { ...state, showNewLawDocument: false };
		case 'LAWDOCUMENT_CREATE_BEGIN':
			return { ...state, loading: true, createdSblId: -1 };
		case 'LAWDOCUMENT_CREATE_SUCCESS':
			if (action.payload.id > 0) {
				document.location.href = `/lagdel/lag/${action.payload.id}`;
				return { ...state, createdSblId: -1, loading: false };
			} else {
				return { ...state, createdSblId: 0, loading: false };
			}

		case 'SBL_SAVE_SUCCESS':
			return { ...state, list: [] };
		case 'SBL_DELETE_SUCCESS':
			return { ...state, list: [] };
		case 'SBL_UPDATE_LEGAL_COMMENT_DATES_SUCCESS':
			alert(action.payload.id + ' lagkommentarer uppdaterades');

			return { ...state };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/lawdocument/lawdocumentReducers.js